<script>
    export default {
        props: [
            'locale',
            'rules',
            'initOrderNotes',
            'route'
        ],
        data() {
            return {
                formatter: null,
                totalA1MinReached: false,
                totalMinReached: false,
                productsA2Positive: false,
                productsDaPositive: false,
                bonusSoPositive: false,
                bonusB1Positive: false,
                bonusOmPositive: false,
                bonusCgPositive: false,
                totalA1Min: 0,
                totalA1: 0,
                totalC1: 0,
                totalMin: 0,
                total: 0,
                productsA2: 0,
                productsA2Max: 0,
                productsDa: 0,
                productsDaMax: 0,
                bonusSo: 0,
                bonusB1: 0,
                bonusOm: 0,
                bonusCg: 0,
                orderNotes: '',
                prizesCampaignTempPoints: 0,
                prizesCampaignDefPoints: 0,
                prizesCampaignTotalPoints: 0,
                nextPrizesKitPercentageCompleted: 0,
                nextPrizesKitPointsLeft: 0,
                prizesCampaign: null
            }
        },
        created: function() {
            var orderSummary = this;

            orderSummary.formatter = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            orderSummary.formatterInteger = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        },
        mounted: function() {
            var orderSummary = this;

            orderSummary.init();

            Event.$on("summaryNeedsUpdate", function(products, product){
                orderSummary.saveSummary(product, false, false);
            });
        },
        methods: {
            init: function() {
                var orderSummary = this;
                orderSummary.orderNotes = orderSummary.initOrderNotes;
            },
            saveSummary: function(product, products, redirect) {
                var orderSummary = this;

                $('.div-preloader', orderSummary.$el).fadeIn();

                var data = {};

                data.orderNotes = orderSummary.orderNotes;

                if(product){
                    data.product = {};
                    data.product.id = product.productId;
                    data.product.quantityA1 = product.quantityA1;
                    data.product.quantityA2 = product.quantityA2;
                    data.product.quantityB1 = product.quantityB1;
                    data.product.quantityOm = product.quantityOm;
                    data.product.quantityCg = product.quantityCg;
                }

                axios.post(this.route, {
                    data: data
                }).then((res) => {
                    var summary = res.data.summary;
                    orderSummary.totalA1Min = Number(summary.totalA1Min);
                    orderSummary.totalA1 = Number(summary.totalA1);
                    orderSummary.totalA1MinReached = Number(summary.totalA1) >= Number(summary.totalA1Min);
                    orderSummary.totalC1 = Number(summary.totalC1);
                    orderSummary.totalMin = Number(summary.totalMin);
                    orderSummary.total = Number(summary.total);
                    orderSummary.totalMinReached = Number(summary.total) >= Number(summary.totalMin);
                    orderSummary.productsA2 = Number(summary.productsA2);
                    orderSummary.productsA2Max = Number(summary.productsA2Max);
                    orderSummary.productsA2Positive = Number(summary.productsA2) <= Number(summary.productsA2Max);
                    orderSummary.productsDa = Number(summary.productsDa);
                    orderSummary.productsDaMax = Number(summary.productsDaMax);
                    orderSummary.productsDaPositive = Number(summary.productsDa) <= Number(summary.productsDaMax);
                    orderSummary.bonusSo = Number(summary.bonusSo);
                    orderSummary.bonusSoPositive = Number(summary.bonusSo) >= 0;
                    orderSummary.bonusB1 = Number(summary.bonusB1);
                    orderSummary.bonusB1Positive = Number(summary.bonusB1) >= 0;
                    orderSummary.bonusOm = Number(summary.bonusOm);
                    orderSummary.bonusOmPositive = Number(summary.bonusOm) >= 0;
                    orderSummary.bonusCg = Number(summary.bonusCg);
                    orderSummary.bonusCgPositive = Number(summary.bonusCg) >= 0;
                    orderSummary.orderNotes = summary.orderNotes;
                    orderSummary.prizesCampaignTempPoints = summary.prizesCampaignTempPoints;
                    orderSummary.prizesCampaignDefPoints = summary.prizesCampaignDefPoints;
                    orderSummary.prizesCampaignTotalPoints = summary.prizesCampaignTotalPoints;
                    orderSummary.nextPrizesKitPercentageCompleted = summary.nextPrizesKitPercentageCompleted;
                    orderSummary.nextPrizesKitPointsLeft = summary.nextPrizesKitPointsLeft;
                    orderSummary.prizesCampaign = summary.prizesCampaign;

                    if(products){
                        $.each(products, function(i, product){
                            if(res.data.products[product.productId] &&
                                res.data.products[product.productId].id == product.productId){
                                product.quantityA1 = res.data.products[product.productId].pivot.quantity_a1;
                                product.quantityA2 = res.data.products[product.productId].pivot.quantity_a2;
                                product.quantityB1 = res.data.products[product.productId].pivot.quantity_b1;
                                product.quantityOm = res.data.products[product.productId].pivot.quantity_om;
                                product.quantityCg = res.data.products[product.productId].pivot.quantity_cg;
                                product.hasQuantity = product.quantityA1 > 0 || product.quantityA2 > 0 ||
                                                        product.quantityB1 > 0 || product.quantityOm > 0 ||
                                                        product.quantityCg > 0;
                            }else{
                                product.quantityA1 = "";
                                product.quantityA2 = "";
                                product.quantityB1 = "";
                                product.quantityOm = "";
                                product.quantityCg = "";
                                product.hasQuantity = product.quantityA1 > 0 || product.quantityA2 > 0 ||
                                                        product.quantityB1 > 0 || product.quantityOm > 0 ||
                                                        product.quantityCg;
                            }
                        });
                    }

                    $('.div-preloader', orderSummary.$el).fadeOut();
                    Event.$emit('summaryUpdated', orderSummary);

                    if(redirect){
                        window.location = redirect;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/orders/orderSummary.vue